import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { CssBaseline, ThemeProvider } from "@mui/material"
import App from "@/App"
import { portfolioTheme } from "@/theme/theme"

const root = document.getElementById("root")
if (!root) throw new Error("Root element not found")

createRoot(root).render(
  <StrictMode>
    <ThemeProvider theme={portfolioTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StrictMode>,
)
